import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../utils/const";
import { Typography } from "@mui/material";
import { Box, display } from "@mui/system";
import styles from "./PostRequirement.module.css";
import { useSelector } from "react-redux";

const SearchSelectedCandiadtesDrawer = ({
  handleClose,
  show,
  row,
  getLocationById,
  toggleSelect,
  selectFilterData,
  selectedJobPost,
  handleOnClickSortList,
}) => {
  const requirementLoading = useSelector(
    (state) => state.postrequirement.status
  );
  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "40%",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography>
          <b>{row?.length > 0 ? row?.length : 0} Profile Shortlisted </b>
        </Typography>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "5px" }}>
        {row?.map((candidate) => {
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: "1px solid #f2f2f2",
                borderRadius: "3px",
                padding: "7px",
                marginTop: "10px",
              }}
            >
              <Box>
                <Typography>
                  <b>{candidate?.full_name}</b>
                </Typography>
                <Typography>
                  {candidate?.current_job_title}, {candidate?.total_experience}{" "}
                  {candidate?.total_experience > 1 ? "Years" : "Year"} Exp
                </Typography>
                <Typography>
                  {getLocationById(candidate?.current_location)}
                </Typography>
              </Box>
              <RxCross2
                style={{
                  fontSize: "22px",
                  cursor: "pointer",
                  color: "red",
                  alignSelf: "start",
                }}
                onClick={() => toggleSelect(candidate?.id)}
              />
            </Box>
          );
        })}
        <Box className={styles.adding_internal_btns} sx={{ marginTop: "50px" }}>
          <button
            style={
              selectedJobPost?.length === 0
                ? { marginLeft: "10px", cursor: "not-allowed" }
                : { marginLeft: "10px" }
            }
            onClick={handleOnClickSortList}
            disabled={selectedJobPost?.length === 0}
          >
            {requirementLoading === "loading"
              ? "Loading"
              : `Send to Candidate (${row?.length > 0 ? row?.length : 0})`}
          </button>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SearchSelectedCandiadtesDrawer;
